import "@/css/main.css";

import "./icons.js";

import "bootstrap";
import $ from "jquery";
import "altcha";

const csrfTokenInput = document.querySelector(
  "input[type='hidden'][name='csrf_token']",
);
export const CSRF_TOKEN = csrfTokenInput.value;

$.ajaxSetup({
  beforeSend: function (xhr, settings) {
    if (
      !/^(GET|HEAD|OPTIONS|TRACE)$/i.test(settings.type) &&
      !this.crossDomain
    ) {
      xhr.setRequestHeader("X-CSRFToken", CSRF_TOKEN);
    }
  },
});
